<template>
  <div class="content-main">
    <HeaderBar :text="handbook.header" :backgroundUrl="handbook.headerUrl"></HeaderBar>
    <div class="content">
      <div class="container">
        <div class="detail">
          <p v-html="handbook.description"></p>
          <div style="width: 100%;" class="text-center">
            <a href="#" @click.prevent="freeze()" :class="{active: handbook.isActive}">
              <i class="fa fa-book" aria-hidden="true"></i> <span>{{handbook.button}}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../COMMON/HeaderBar.vue'

export default {
  components: {
    HeaderBar
  },
  props: ['handbook'],
  methods: {
    freeze: function () {}
  }
}
</script>

<style scoped>

  .content-main {
    padding-bottom: 60px 0;
  }

  .content {
    padding: 30px 0;
  }

  p {
    margin-bottom: 30px;
  }

  a {
    display: block;
    width: fit-content;
    margin: auto;
    padding: 5px 15px;
    height: auto;
    border: 2px solid #FFA500;
    border-radius: 15px;
    user-select: none;
    transition: 0.35s;
    cursor: not-allowed
  }

  a.active {
    cursor: pointer;
  }

  a span {
    font-size: 32px;
  }

  .fa-book {
    font-size: 48px;
  }

  a:hover {
    background-color: #FFA500;
  }

  a:hover i {
    color: #FFF;
  }

  a:hover span {
    color: #FFF;
    text-decoration: underline;
  }

</style>



// WEBPACK FOOTER //
// src/components/STUDENTS/Handbook.vue